import { AlertsService } from '../../service/alerts.service'
import axios from 'axios'
import { GlobalUtility } from '../../service/global-utility.service'
import {
  CREW_TRAINING_DETAILS,
  CREW,
  CREW_PCRS, CREW_RECORD
} from '../../service/constants.service'

const state = {
  crew: {},
  crews: [],
  trainings: [],
  booking: {},
  family: {},
  pcrs: [],
  crewExperience: [],
  newCrew: {},
  objRanks: []
}

const mutations = {
  set_crews: (state, params) => {
    state.crews = params
  },

  set_crew (state, params) {
    state.crew = params
  },

  set_crew_training_dtls: (state, params) => {
    state.trainings = params
  },

  set_active_booking_dtls: (state, params) => {
    state.booking = params
  },

  set_family: (state, params) => {
    state.family = params
  },

  set_pcrs: (state, params) => {
    state.pcrs = params
  },

  set_null_crew: (state, params) => {
    state.crew = {}
  },

  create_new_crew (state, payload) {
    if (payload != null) {
      state.newCrew = {}
    }
  },

  set_obj_ranks (state, payload) {
    state.objRanks = payload
  },

  reset_new_crew (state) {
    state.newCrew = {}
  }
}

const actions = {
  async getCrewList ({ commit }, params) {
    const url = `${CREW}?page=${params.page}`
    return await axios.get(url, { params }).then((response) => {
      console.log('This is something ,', response)
      commit('set_crews', response.data.crewListPaginated.data)
      commit('set_crew_pagination', response.data.crewListPaginated)
      commit('set_obj_ranks', response.data.objRanks)
      return true
    }).catch((error) => {
      GlobalUtility.failProgressBar()
      GlobalUtility.generateResponseMessage(error, 'Get Crew List')
      // console.log();
      return false
    })
  },

  async getCrewDetail ({ commit }, param) {
    return await axios.get(`${CREW}/${param}`).then((response) => {
      commit('set_crew', response.data)
      commit('set_obj_ranks', response.data.objRanks)
      return true
    }).catch((error) => {
      GlobalUtility.failProgressBar()
      GlobalUtility.generateResponseMessage(error, 'Get Crew Detail')
      return false
    })
  },

  async getCrewTrainingDetails ({ commit }, params) {
    return axios.get(CREW_TRAINING_DETAILS, { params }).then((response) => {
      const trainings = response.data.trainingCourse
      commit('set_crew_training_dtls', trainings)
      return true
    }).catch((error) => {
      GlobalUtility.failProgressBar()
      GlobalUtility.generateResponseMessage(error, 'Get Crew Training Details')
      return false
    })
  },

  getCrewFamily ({ commit }) {
    commit('set_family')
  },

  getActiveBookingDetails ({ commit }) {
    commit('set_active_booking_dtls')
  },

  getCrewExperience ({ commit }) {

  },

  async getCrewPCRS ({ commit }, param) {
    return await axios.get(`${CREW_PCRS}/${param}`).then((response) => {
      commit('set_pcrs', response.data)
      return true
    }).catch((error) => {
      GlobalUtility.failProgressBar()
      GlobalUtility.generateResponseMessage(error, 'Get Crew PCRS')
      return false
    })
  },

  setCrewNull ({ commit }) {
    commit('set_null_crew')
  },

  create_new_crew ({ commit }, param) {
    console.log('create_new_crew:', param)
    return axios.post(CREW_RECORD, param).then((r) => {
      console.log('create_new_crew:success', r.data)
      commit('create_new_crew', r.data)
      return true
    }).catch((er) => {
      console.log('create_new_crew:', er)
      GlobalUtility.failProgressBar()
      GlobalUtility.generateResponseMessage(er, 'Crew Records')
      return false
    })
  },

  reset_new_crew ({ commit }) {
    commit('reset_new_crew')
  },

  async updateCrewRank ({ commit }, payload) {
    return await axios.post(`${CREW}/updateRank`, payload).then((r) => {
      if (r) {
        AlertsService.successActionAlert('Update Rank Successfully', 'Update')
        return true
      }
    }).catch((er) => {
      console.log('Checking error', er)
      return false
    })
  }
}

const getters = {
  crews: state => GlobalUtility.capitalizeProperties(state.crews),
  crew: state => state.crew,
  trainings: state => state.trainings,
  booking: state => state.booking,
  family: state => state.family,
  crewExperience: state => state.crewExperience,
  pcrs: state => state.pcrs,
  newCrew: state => state.newCrew,
  objRanks: state => state.objRanks
}

export default { state, actions, mutations, getters }
